/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler } from './services/core/error.service';
import { AuthService } from './services/core/auth.service';
import { LoggerService } from './services/core/logger.service';
import { CommonModule } from '@angular/common';
import { CSVSurveyDataApi } from './services/custom/CSVSurveyDataApi';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AuthApi } from './services/custom/AuthApi';
import { CommonApi } from './services/custom/CommonApi';
import { CompanyDataApi } from './services/custom/CompanyDataApi';
import { CompanyDataFieldApi } from './services/custom/CompanyDataFieldApi';
import { DisaggregationTypeApi } from './services/custom/DisaggregationTypeApi';
import { DocumentApi } from './services/custom/DocumentApi';
import { EmailApi } from './services/custom/EmailApi';
import { FrameworkUtrApi } from './services/custom/FrameworkUtrApi';
import { FrameworkPlannerApi } from './services/custom/FrameworkPlannerApi';
import { ImpactLevelApi } from './services/custom/ImpactLevelApi';
import { InitiativeApi } from './services/custom/InitiativeApi';
import { InitiativeGroupApi } from './services/custom/InitiativeGroupApi';
import { MaintenanceApi } from './services/custom/MaintenanceApi';
import { MessageApi } from './services/custom/MessageApi';
import { MetricUnitApi } from './services/custom/MetricUnitApi';
import { OnboardingApi } from './services/custom/OnboardingApi';
import { OrganizationApi } from './services/custom/OrganizationApi';
import { ReferenceDataApi } from './services/custom/ReferenceDataApi';
import { ReportingFrameworkApi } from './services/custom/ReportingFrameworkApi';
import { SurveyApi } from './services/custom/SurveyApi';
import { SurveySourcesApi } from './services/custom/SurveySourcesApi';
import { UniversalTrackerApi } from './services/custom/UniversalTrackerApi';
import { UniversalTrackerGroupApi } from './services/custom/UniversalTrackerGroupApi';
import { UniversalTrackerScheduleApi } from './services/custom/UniversalTrackerScheduleApi';
import { UniversalTrackerValueApi } from './services/custom/UniversalTrackerValueApi';
import { UserApi } from './services/custom/UserApi';
import { UserEventsApi } from './services/custom/UserEventsApi';
import { OnboardingListApi } from './services/custom/OnboardingListApi';
import { ValueListApi } from './services/custom/ValueListApi';
import {PilotTrackerApi} from './services/custom';
import { DataShareApi } from './services/custom/DataShareApi';

@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
  ]
})

export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        AuthService,
        LoggerService,
        AuthApi,
        CommonApi,
        CompanyDataApi,
        CompanyDataFieldApi,
        CSVSurveyDataApi,
        DataShareApi,
        DisaggregationTypeApi,
        DocumentApi,
        EmailApi,
        FrameworkUtrApi,
        FrameworkPlannerApi,
        ImpactLevelApi,
        InitiativeApi,
        InitiativeGroupApi,
        MaintenanceApi,
        MessageApi,
        MetricUnitApi,
        OrganizationApi,
        OnboardingApi,
        OnboardingListApi,
        PilotTrackerApi,
        ReferenceDataApi,
        ReportingFrameworkApi,
        SurveyApi,
        SurveySourcesApi,
        UniversalTrackerApi,
        UniversalTrackerGroupApi,
        UniversalTrackerScheduleApi,
        UniversalTrackerValueApi,
        UserApi,
        UserEventsApi,
        ValueListApi,
      ]
    };
  }
}

export * from './services';
